<ion-header>
  <ion-toolbar>
    <ion-back-button slot="start"></ion-back-button>
    <ion-title>{{ masterTemplate ? 'Edit' : 'Create' }} Master Template</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <super-step-item count="1" [isTopLine]="false" [success]="collectionTemplate?.purpose?.length > 0">
    <ion-list>
      <ion-item>
        <ion-label position="stacked">Template Name</ion-label>
        <ion-input class="template-name-input" placeholder="Enter name here"
          [(ngModel)]="collectionTemplate.purpose"></ion-input>
      </ion-item>
    </ion-list>
  </super-step-item>

  <super-step-item count="2" [success]="collectionTemplate?.acceptedIds?.length > 0">
    <ion-list>
      <ion-item button="" (click)="openIdSetter()">
        <ion-label>
          <h2>Set IDs</h2>
          <p>Click to choose IDs that you want to collect from your customer</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </super-step-item>

  <super-step-item count="3" [success]="collectionTemplate?.otherInfo?.length > 0">
    <ion-list>
      <ion-item button="" (click)="openFieldSetter()"
        [class.step-complete]="collectionTemplate?.acceptedIds?.length > 0">
        <ion-label>
          <h2>Set Other Field</h2>
          <p>Click to add fields like Name, Phone, Email, etc.</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </super-step-item>

  <super-step-item count="4" [isBottomLine]="false">
    <ion-list>
      <ion-list-header>
        <ion-label>Industries</ion-label>
      </ion-list-header>

      @for (industry of industries; track industry) {
        <ion-item>
          <ion-label>{{ industry.name }}</ion-label>
          <ion-checkbox [checked]="isIndustrySelected()" (click)="onIndustryToggle(industry._id)"></ion-checkbox>
        </ion-item>
      }
    </ion-list>
  </super-step-item>

  <page-action>
    <!-- TODO: Add buttons here -->
    <!-- <super-button
      *ngIf="!masterTemplate"
      [action]="createMasterTemplate"
      [showError]="true"
      >Create Master Template
    </super-button>
    <super-button
      *ngIf="masterTemplate"
      [action]="createMasterTemplate"
      [showError]="true"
      >Update Master Template
    </super-button> -->
  </page-action>
</ion-content>